import { DocumentFragments } from '@/apollo/fragments/document';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { IDocument, PrivacyDocument } from '@/types/api';
import gql from 'graphql-tag';
import { DocumentForm } from '.';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdatePrivacy($input: UpdatePrivacyInput!) {
        updatePrivacy(input: $input) {
          privacy {
            ...Document
          }
        }
      }
      ${DocumentFragments.Document}
    `,
    refetchQueries: ['Privacy'],
  },
})
export class UpdatePrivacyForm extends GraphQLForm<IDocument> implements DocumentForm {
  @Field()
  public html: string;

  constructor(old: PrivacyDocument) {
    super();
    this.html = old.html;
  }
}
